// extracted by mini-css-extract-plugin
export default {"hidden":"Ar0qqi","container":"f6o2be","controls-showed":"B0TlqF","controlsShowed":"B0TlqF"};